export function ComingSoon() {
  return (
    <div>
      <h1>Coming Soon</h1>
      <p>App Store release coming soon!</p>
      <p>Stay tuned for the official launch of our TOKO Math apps.</p>
    </div>
  );
}
